import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiMap, FiExternalLink } = FiIcons;

const Approach = () => {
  return (
    <section id="approach" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-16">
            <div className="md:w-1/2">
              <h2 className="text-3xl md:text-4xl font-bold text-black mb-8">
                System-Architektur vor Technik
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Ein Architekt ist kein Bauarbeiter. Wir liefern den Plan, nach dem Ihr Haus gebaut wird. Wir stellen sicher, dass die Statik Ihrer Prozesse stimmt, bevor Sie in teure Technologien investieren.
              </p>
              
              <div className="space-y-8">
                <div className="flex items-start">
                  <div className="bg-azure-50 p-3 rounded-lg mr-4">
                    <SafeIcon icon={FiSearch} className="text-azure-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="font-bold text-black text-lg">Entscheidungslogik prüfen</h4>
                    <p className="text-gray-600">Wir analysieren, ob Ihre Prozesse logisch reif für eine Automatisierung sind.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-azure-50 p-3 rounded-lg mr-4">
                    <SafeIcon icon={FiMap} className="text-azure-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="font-bold text-black text-lg">System-Architektur entwerfen</h4>
                    <p className="text-gray-600">Sie erhalten ein präzises Diagramm Ihrer zukünftigen Systemlandschaft.</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-16">
                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-6">Ergänzende Kompetenzen in unserem Netzwerk</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 -mx-2">
                  <div className="mx-2 p-6 bg-gray-50 rounded-2xl border border-gray-100 flex flex-col min-w-[110%] sm:min-w-0">
                    <p className="text-gray-800 font-bold mb-2">DIFE-Institut</p>
                    <p className="text-gray-600 text-xs mb-4 flex-grow">Prüflogik und strategisches Denken für nachhaltige Systeme.</p>
                    <a href="https://dife-institut.de" target="_blank" rel="noopener noreferrer" className="text-azure-600 text-sm font-bold flex items-center hover:underline mt-auto">
                      dife-institut.de <SafeIcon icon={FiExternalLink} className="ml-1" />
                    </a>
                  </div>
                  
                  <div className="mx-2 p-6 bg-azure-50 rounded-2xl border border-azure-100 flex flex-col min-w-[110%] sm:min-w-0">
                    <p className="text-azure-900 font-bold mb-2">Smarte-Buchhaltung.online</p>
                    <p className="text-azure-700 text-xs mb-4 flex-grow">Prozessoptimierung der Buchhaltung passend zur K³ System-Architektur.</p>
                    <a href="https://smarte-buchhaltung.online" target="_blank" rel="noopener noreferrer" className="text-azure-600 text-sm font-bold flex items-center hover:underline mt-auto">
                      Besuchen <SafeIcon icon={FiExternalLink} className="ml-1" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="md:w-1/2">
              <div className="relative">
                <div className="absolute -inset-10 bg-azure-100 rounded-full blur-3xl opacity-20"></div>
                <motion.div 
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                  className="relative bg-white p-4 rounded-3xl shadow-2xl border border-gray-100"
                >
                  <img 
                    src="https://github.com/mike3011/Bilder/blob/main/ChatGPT%20Image%2013.%20Feb.%202026,%2016_09_55.png?raw=true" 
                    alt="System-Architektur Bauplan" 
                    className="rounded-2xl w-full"
                  />
                  <div className="absolute bottom-8 right-8 bg-black text-white px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-widest">
                    Architekt vs. Bauarbeiter
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Approach;